import React ,{ useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Spinner from 'react-bootstrap/Spinner'

import '../../css/header.css';
import '../../font/dana/fontiran.css';
import {Navbar, NavDropdown, Nav, Dropdown ,Button ,ButtonGroup } from 'react-bootstrap';

//import language_icon from '../../images/language2.png'
//import En from '../../images/En.png'
//import Fa from '../../images/Fa.pn
//import Fr from '../../images/Fr.png'

import '../../font/dana/style.css';
import '../../css/style.css';
import LoadingMenu from './LoadingMenu';


const Header = (props) => {
    
    const [loadingShow,setLoadingShow] = useState(false);
    const [languageInfo,setLanguageInfo] = useState(undefined);
    const [menuItems,setMenuItems] = useState(undefined);
    const [languages,setLanguages] = useState(undefined);

    useEffect(() => {
        async function fetchData() {
            setLoadingShow(true);

            var languageInfoVar = '';

            if (props.languageInfo!=null)
            {
                languageInfoVar = props.languageInfo
                //console.log(LanguageInfo[0].Code);
            }else{
                languageInfoVar = [{Code:"fa",Title:"فارسی",Direction:"rtl"}];
            }

            setLanguageInfo(languageInfoVar);
            //props.setLanguageInfo(languageInfoVar)

            const responseResultLanguages = await webapi.get('pages/languages/'+languageInfoVar[0].Code);
            //console.log(responseResultlanguages.data);
            setLanguages(responseResultLanguages.data);

            const responseResultMenus = await webapi.get('pages/menu/'+ languageInfoVar[0].Code );
            //console.log(responseResult.data);
            setMenuItems(responseResultMenus.data);

            setLoadingShow(false);
        }
        fetchData();
    }, [props.languageInfo]);

    
    if  (loadingShow===false){
        if (menuItems && menuItems.length>0) {
            return (
                <div>
                    <div className="container-fluid" id="navbar_container_fluid"  style={{display: 'flex'}}>
                    <div className="container"> 
                        <div id="menu_container">
                            <Navbar bg="light" expand="lg">
                                {/* <Navbar.Brand href="/">پارسیگ دیتابیس</Navbar.Brand> */}
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="mr-auto">
                                        {
                                            menuItems.map((menuItem,j) =>{
                                                return  (
                                                    (menuItem.URL!=='.' && !menuItem.SubMenu)
                                                    ?
                                                    <Nav.Link key={menuItem.Code} href={process.env.PUBLIC_URL+menuItem.URL+'?lang='+languageInfo[0].Code}>{menuItem.Title}</Nav.Link>
                                                    :
                                                    <NavDropdown key={menuItem.Code} title={menuItem.Title}>
                                                        {
                                                            (menuItem.SubMenu)
                                                            ?
                                                            menuItem.SubMenu.map((submenu,i) =>{
                                                                return  (
                                                                    (i===0)
                                                                    ?
                                                                    <div key={'i'+submenu.Code}>
                                                                        <NavDropdown.Item key={'j'+submenu.Code} href={process.env.PUBLIC_URL+submenu.URL+'/?lang='+languageInfo[0].Code}>{submenu.Title}</NavDropdown.Item>
                                                                    </div>
                                                                    :
                                                                    <div key={'k'+submenu.Code}>
                                                                        <NavDropdown.Divider key={'k'+submenu.Code} />
                                                                        <NavDropdown.Item key={'l'+submenu.Code} href={process.env.PUBLIC_URL+submenu.URL+'/?lang='+languageInfo[0].Code}>{submenu.Title}</NavDropdown.Item>
                                                                    </div>
                                                                )
                                                            }
                                                            )
                                                            :
                                                            null
                                                        }
                                                    </NavDropdown>
                                                )                                                                
                                            })                                                        
                                        } 
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </div>
                        <div id="navbar_container" style={{Direction:'rtl'}}>
                            <div className="nav-item dropdown">
                                <div className="dropdown">
                                    <Dropdown as={ButtonGroup} style={{marginTop:'1px'}}>
                                        <Button variant="light" href={"?lang="+ languages[0].Code}> 
                                            <div className="lang_switch">
                                                {languages[0].Title}
                                                {/* <img id="language_icon" alt="01" src={require('../../images/'+languages[0].Code+'.png')} /> */}
                                            </div>
                                        </Button>
                                        <Dropdown.Toggle split variant="light" id="dropdown-split-basic" />
                                        
                                        <Dropdown.Menu>
                                        {
                                            languages.map((languagesItem,j) =>{
                                                return (
                                                    <Dropdown.Item key= {languagesItem.Code} href={"?lang="+ languagesItem.Code}>
                                                        <div id="lang_dropdoan">
                                                                    <span className='td_lang_tilte'>
                                                                        {languagesItem.Title}
                                                                    </span>
                                                                    {/* <span className='td_lang_flag'>
                                                                        <img id="language_icon" alt="01" src={require('../../images/'+languagesItem.Code+'.png')} />
                                                                    </span> */}
                                                                    </div>
                                                    </Dropdown.Item>
                                                )
                                            })
                                        }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>
                </div>
            )
        }
        else
        {
            return null
        }
    }
    else
    {
        return(
            //<LoadingMenu />
            <div style={{position: 'relative',display: 'flex',justifycontent: 'center',alignitems: 'center',width:'100%',height:'48px'}}>
                <div style={{position: 'absolute',top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                    <Spinner
                    as="span"
                    variant="dark"
                    role="status"
                    aria-hidden="true"
                    animation="border"/>
                </div>
            </div>
        )
    }
 }

 export default Header;
